import apiClient from '../../shared/services/apiClient';

/**
 * 邮件推送（TM，纯发信）— /api/user/tm/*（见 api/docs/tm-architecture.md）。
 * 每个方法返回后端 body（{success, data, message}）；HTTP 4xx/5xx 时抛出 {success:false, error, status, ...body}。
 */
const BASE = '/api/user/tm';

const call = async (p) => {
    try {
        const res = await p;
        return res.data;
    } catch (e) {
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { ...body, success: false, status: e?.response?.status, error: body.error || body.message || e?.message };
    }
};
const get = (url, params, cfg = {}) => call(apiClient.get(`${BASE}${url}`, { params, ...cfg }));
const post = (url, data, cfg = {}) => call(apiClient.post(`${BASE}${url}`, data || {}, cfg));
const quiet = { skipGlobalErrorToast: true };

const tmService = {
    // 发信流
    listStreams: () => get('/streams'),
    getStream: (id) => get(`/streams/${id}`),
    updateStream: (id, data) => post(`/streams/${id}/update`, data),
    releaseSandbox: (id) => post(`/streams/${id}/release-sandbox`, {}, quiet),
    deleteStream: (id) => post(`/streams/${id}/delete`, {}, quiet),
    getSmtp: (id) => get(`/streams/${id}/smtp`),
    getStats: (id, days = 7) => get(`/streams/${id}/stats`, { days }),

    // Webhook
    getWebhook: (id) => get(`/streams/${id}/webhook`),
    saveWebhook: (id, data) => post(`/streams/${id}/webhook`, data),
    testWebhook: (id) => post(`/streams/${id}/webhook/test`, {}, quiet),
    getWebhookDeliveries: (id) => get(`/streams/${id}/webhook/deliveries`),

    // API 密钥（同时是 SMTP 密码）
    listApiKeys: (streamId) => get(`/streams/${streamId}/api-keys`),
    createApiKey: (streamId, name) => post(`/streams/${streamId}/api-keys/create`, { name }),
    revokeApiKey: (keyId) => post(`/api-keys/${keyId}/revoke`),

    // 发信域名
    listDomains: (params) => get('/domains', params),
    getDomain: (id) => get(`/domains/${id}`),
    createDomain: (data) => post('/domains/create', data),
    verifyDomain: (id) => post(`/domains/${id}/verify`),
    updateDomain: (id, data) => post(`/domains/${id}/update`, data),
    deleteDomain: (id) => post(`/domains/${id}/delete`),

    // 发送记录
    listMessages: (params) => get('/messages', params),
    getMessage: (id) => get(`/messages/${encodeURIComponent(id)}`),

    // 抑制名单
    listSuppressions: (params) => get('/suppressions', params),
    createSuppression: (data) => post('/suppressions/create', data),
    deleteSuppression: (id) => post(`/suppressions/${id}/delete`),

    // 信用等级（账号级）；迁移未执行时 data 为 null
    getTrust: () => get('/trust', undefined, quiet),

    // 沙箱收件人
    listRecipients: () => get('/recipients'),
    createRecipient: (email) => post('/recipients/create', { email }),
    deleteRecipient: (id) => post(`/recipients/${id}/delete`),

    // 套餐（公开产品列表，product_type=tm；隐藏内部套餐）
    listPlans: async () => {
        const body = await call(apiClient.get('/products', { params: { product_type: 'tm', status: 'active' } }));
        const list = Array.isArray(body?.data) ? body.data : [];
        return list.filter((p) => p.status === 'active' && p.slug !== 'tm-internal' && !(p.features || {}).tm_internal);
    },
};

export default tmService;
